import { makeStyles } from 'e100-react-components';

export const useStyles = makeStyles(({
  spacing,
  palette,
  shape,
  shadows
}) => ({
  root: {
    marginBottom: spacing(2),
    borderBottom: `1px solid ${palette.grey[200]}`,
    padding: `${spacing(0.5)}px ${spacing()}px 0 ${spacing()}px`,
    '& input': {
      padding: `${spacing(2.5)}px ${spacing(5)}px ${spacing(2.5)}px ${spacing(2)}px !important`
    }
  },
  inputRoot: {
    paddingRight: `${0} !important`,

    '&:after': {
      display: 'none'
    },
    '&:before': {
      display: 'none'
    }
  },
  focused: {
    '& > div': {
      boxShadow: shadows['10'],
      borderRadius: `${shape.borderRadius}px ${shape.borderRadius}px 0 0`
    }
  },
  container: {
    position: 'relative'
  },
  popper: {
    top: spacing(6.9),
    left: spacing(),
    width: `calc(100% - ${spacing(2)}px) !important`,
    '& > div': {
      borderRadius: `0 0 ${shape.borderRadius}px ${shape.borderRadius}px`,
      boxShadow: shadows['10'],
    }
  },
  endAdornment: {
    display: 'none'
  },
  startAdornment: {
    marginLeft: spacing(2.25)
  }
}));